import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const JobSearchPage = lazy(() => import('../pages/job-search/page'));
const ForBeginnersPage = lazy(() => import('../pages/for-beginners/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/job-search',
    element: <JobSearchPage />,
  },
  {
    path: '/for-beginners',
    element: <ForBeginnersPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
